/** Sidebar navigation for documentation and legal pages. */

export const LEGAL_NAV_SECTIONS = [
  {
    title: 'Guide',
    items: [
      { path: '/products', label: 'Products', description: 'Apps and tools on Bahlus' },
      { path: '/docs', label: 'Documentation', description: 'What Bahlus is and how it works' },
    ],
  },
  {
    title: 'Legal & policies',
    items: [
      { path: '/privacy', label: 'Privacy Policy' },
      { path: '/terms', label: 'Terms & Conditions' },
      { path: '/legal/code-of-conduct', label: 'Code of Conduct' },
      { path: '/legal/acceptable-use', label: 'Acceptable Use & Misuse' },
      { path: '/legal/fair-use', label: 'Fair Use Policy' },
      { path: '/legal/safety', label: 'Safety & Reporting' },
      { path: '/legal/regional', label: 'Regional Compliance' },
      { path: '/legal/open-source', label: 'Open Source Licenses' },
    ],
  },
  {
    title: 'Support',
    items: [
      { path: '/contact', label: 'Contact Us' },
    ],
  },
];

export function findLegalNavItem(pathname) {
  for (const section of LEGAL_NAV_SECTIONS) {
    const match = section.items.find((item) => item.path === pathname);
    if (match) return match;
  }
  return null;
}
